import ApiClient from 'apis/ApiClient'
import _ from 'lodash'
import { setAmplitudeProfile } from 'utils/amplitudeInit'
import uuid from 'react-uuid'
import { getPartnerId } from 'utils/authLocalStorage'
import { setWWBmi } from 'utils/wwLocalStorage'
import { PARTNER_ID } from 'utils/basic'
const apiClient = new ApiClient()

export const uploadProfilePromise = (options = {}) => {
  return apiClient.put('/user', {
    body: {
      ...options,
    },
  })
}

export const getProfilePromise = (authContext) => {
  return apiClient.get('/user').then((resp) => {
    if (+getPartnerId() === PARTNER_ID.REVIVE) {
      setWWBmi(resp.data.currentBmi)
    }
    authContext &&
      authContext.dispatch({ type: 'SET_PROFILE', payload: resp.data })
    resp.data && setAmplitudeProfile(resp.data)
    return Promise.resolve(resp.data)
  })
}

export function getPartnerGoalPromise() {
  return apiClient
    .get(`/partner/user/goal`, { cacheTtl: 60 * 60 * 1000 })
    .then((resp) => {
      resp.data && setAmplitudeProfile(resp.data)
      return Promise.resolve(resp.data)
    })
}

export function updatePartnerGoalPromise(options = {}) {
  ApiClient.clearCache('/partner/user/goal')
  return apiClient.put(`/partner/user/goal`, {
    body: {
      ...options,
    },
  })
}
export function updatePartnerGoalPromiseWithId(options = {}) {
  ApiClient.clearCache('/partner/user/goal')
  return apiClient.post(`/partner/user/goal`, {
    body: {
      ...options,
    },
  })
}

export const getProgressAndWeightPromise = () => {
  return apiClient
    .get('/user/progress_weight', {
      params: {
        type: 'part',
      },
    })
    .then((resp) => Promise.resolve(resp.data))
}

export const deleteWeightPromise = (weightId) => {
  return apiClient
    .delete(`/user/weight/${weightId}`)
    .then((resp) => Promise.resolve(resp))
}

export const addUserWeightPromise = (weight, unit, weightDate) => {
  return apiClient.put('/user/weight', {
    body: {
      weight: weight,
      unit: unit,
      weightDate: weightDate,
    },
  })
}

export const loginWithPartnerPromise = (
  clientId,
  partnerUserId,
  clientSecret,
  age,
  bmi,
  gender,
  conditionParams,
  cb
) => {
  return apiClient
    .post('/user/partner/login', {
      body: {
        clientId: clientId,
        partnerUserId: partnerUserId,
        deviceId: uuid(),
        clientSecret: clientSecret,
        age: age,
        bmi: bmi,
        gender: gender,
        conditionParams,
      },
      failCb: cb,
    })
    .then((resp) => {
      return Promise.resolve(resp)
    })
}

export const userFeedbackPromise = (content) => {
  return apiClient
    .post('/user/feedback', {
      body: {
        content: content,
      },
    })
    .then((resp) => {
      const data = _.get(resp, 'data', {})
      if (!data.token) {
        return Promise.resolve(resp)
      }
      return Promise.resolve({
        ...data,
      })
    })
}

export const getWeightSummaryPromise = (params = {}) => {
  return apiClient
    .get(`/user/weight/summary`, {
      params,
    })
    .then((resp) => {
      return Promise.resolve(resp.data)
    })
}
